import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// V4 Final Cache Buster: {new Date().getTime()}
// Dieser Kommentar erzwingt ein Neuladen der Module im Browser

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)